export default defineNuxtRouteMiddleware(() => {
  const { isProd } = useEnvironmentConfig()
  if (isProd)
    throw createError({ statusCode: 404, statusMessage: 'Not Found' })
})
